import React from 'react';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import SelectComponent from '../../../../common/Select';
import { showModal } from '../../../../../actions/modal';
import { EDIT_ORDER_STATUS_OPTIONS } from './../../../../../config/index';
import { fetchPostOrderChangeStatus } from '../../../../../actions/admin';
import { useAutoTranslation } from '../../../../../helpers/useAutoTranslation';

const EditOrderStatus = ({ currentOrderId, actualizeOrder }) => {
  const dispatch = useDispatch();

  const { t } = useAutoTranslation();

  const [orderStatus, setOrderStatus] = useState({ label: t('Не выбран'), value: false });

  const handleRequestChangeOrderStatus = async (infoStatus) => {
    const body = {
      orderId: currentOrderId,
      infoStatus,
    };

    try {
      await dispatch(fetchPostOrderChangeStatus(body));
      await actualizeOrder(currentOrderId);
    } catch (error) {}
  };

  const handleChangeOrderStatus = (option) => {
    setOrderStatus(option);

    if (option.value) {
      dispatch(
        showModal('ConfirmChangeOrderStatus', {
          submitCallback: () => handleRequestChangeOrderStatus(option.value),
          title: `${t('Заказ')} #${currentOrderId}`,
          actionName: t('Да'),
          content: (
            <p>
              {t('Будет выполнен перевод заказа в статус')} <b>"{t(option.label)}"</b>.{' '}
              {t('Подтверждаете')}?
            </p>
          ),
        }),
      );
    }
  };

  return (
    <SelectComponent
      label={t('Изменить статус заказа')}
      options={EDIT_ORDER_STATUS_OPTIONS}
      value={orderStatus}
      isClearable={false}
      onChange={(option) => handleChangeOrderStatus(option)}
    />
  );
};

export default EditOrderStatus;
